module.exports = __webpack_public_path__ + "static/img/sx_banner.5472255.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/sx_banner.png
// module id = bLqX
// module chunks = 167